import { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_URL } from '../config/api';
import logService from '../services/logService';
import ScrapPurchase from './ScrapPurchase';
import './MobileSheets.css';
import './MobileHurda.css';

// iOS admin uygulamasının WebView'da açtığı Hurda Alım ekranı: /mobile/hurda
// Web'deki ScrapPurchase'ın kendisi (aynı liste, fiş detayı, yeni alım ve düzenleme modalları) mobileApp
// modunda çizilir; ana görünüm ScrapMobileHome, modallar MobileSheets.css + MobileHurda.css.
// Oturum token'ı iOS'tan gelir (window.__akikAuthToken → utils/apiAuth.js); kullanıcı bilgisi
// yetki/mağaza ve log kayıtları için /auth/verify'dan alınır. index.js bu yolu App olmadan render eder.
function MobileHurda() {
  const [user, setUser] = useState(null);
  const [authFailed, setAuthFailed] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('mhd-html');
    document.title = 'Hurda Alım';
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');
    return () => root.classList.remove('mhd-html');
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/auth/verify`)
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (cancelled) return;
        if (!data?.user) { setAuthFailed(true); return; }
        setUser(data.user);
        logService.setContext(data.user, null);
      })
      .catch(() => { if (!cancelled) setAuthFailed(true); });
    return () => { cancelled = true; };
  }, []);

  return (
    <MemoryRouter>
      <div className="mhd-page">
        {/* Kullanıcı gelmeden render edilirse mağaza belirlenemez (liste ve yeni alım mağazaya bağlı) */}
        {user ? (
          <ScrapPurchase user={user} selectedStore={null} mobileApp />
        ) : (
          <div className="mhd-status">
            {authFailed ? 'Oturum doğrulanamadı. Aşağı çekip yenileyin veya uygulamaya tekrar giriş yapın.' : 'Yükleniyor…'}
          </div>
        )}
      </div>
      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar
        newestOnTop
        closeOnClick
        draggable
        pauseOnFocusLoss={false}
        theme="colored"
        limit={2}
      />
    </MemoryRouter>
  );
}

export default MobileHurda;
